import apiClient from '../lib/apiClient'

export const authService = {
  async login(email, password) {
    const response = await apiClient.post('/login', {
      user: { email, password },
    })
    return response.data
  },

  async signup(email, password, passwordConfirmation, name) {
    const response = await apiClient.post('/signup', {
      user: { email, password, password_confirmation: passwordConfirmation, name },
    })
    return response.data
  },

  async requestVerificationCode(email) {
    const response = await apiClient.post('/provisional_auth', { email })
    return response.data
  },

  async verifyCode(email, code) {
    const response = await apiClient.post('/provisional_auth/verify', { email, code })
    return response.data
  },

  async upgradeAccount(name, password, passwordConfirmation) {
    const response = await apiClient.put('/signup', {
      user: { name, password, password_confirmation: passwordConfirmation },
    })
    return response.data
  },

  // Roster claim-link onboarding. Preview the invite (name + group + team)
  // for a claim token without authenticating.
  async getClaim(token) {
    const response = await apiClient.get(`/claim/${token}`)
    return response.data
  },

  // Consume the claim link: set the student's email + password (+ name) and
  // receive a JWT, serialized user, and a landing hint.
  async claim(token, { email, password, passwordConfirmation, name }) {
    const response = await apiClient.post(`/claim/${token}`, {
      user: { email, password, password_confirmation: passwordConfirmation, name },
    })
    return response.data
  },

  async requestPasswordReset(email) {
    const response = await apiClient.post('/password', {
      user: { email },
    })
    return response.data
  },

  async resetPassword(token, password, passwordConfirmation) {
    const response = await apiClient.put('/password', {
      user: {
        reset_password_token: token,
        password,
        password_confirmation: passwordConfirmation,
      },
    })
    return response.data
  },

  // Update the signed-in player's accessibility prefs. The backend merges only
  // the allowlisted a11y keys and returns the full updated user.
  async updateAccessibility(a11y) {
    const response = await apiClient.patch('/current_user', { user: { a11y } })
    return response.data
  },

  async logout() {
    try {
      await apiClient.delete('/logout')
    } catch (e) {
      // Ignore logout failures — clear local state regardless
    }
  },
}
